
<template>
  <div>
    <v-card flat>
      <v-card-text class="px-lg-10 pl-0">
        <v-timeline dense clipped>
          <v-slide-x-transition group>
            <v-timeline-item
              v-for="(comment, idx) in comments"
              :key="idx"
              class="mb-4"
              color="pink"
              small
            >
              <v-row justify="space-between">
                <v-col
                  cols="7"
                  v-text="comment.body"
                ></v-col>
                <v-col
                  class="text-right"
                  cols="5"
                  v-text="$dayjs(comment.date).format('DD/MM/YY HH:mm')"
                ></v-col>
              </v-row>
            </v-timeline-item>
          </v-slide-x-transition>
        </v-timeline>
      </v-card-text>  
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ConsolidationsComments',
  props: {
    comments: {
      type: Array,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>